import React from 'react';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { InfoIcon } from 'components/icons';
import { useFormViewerScreen } from '../../../../index';

interface CantRespondDraftFormAlertProps {
  canEdit: boolean;
}

export const CantRespondDraftFormAlert = ({
  canEdit,
}: CantRespondDraftFormAlertProps) => {
  const { setCurrentScreen } = useFormViewerScreen({
    canEdit,
    isDraft: true,
  });

  return (
    <Alert
      status="warning"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={6}
      borderRadius="lg"
    >
      <InfoIcon size="4x" />
      <AlertTitle
        mt={6}
        mb={1}
        fontSize="lg"
      >{t`You can't respond to a draft form`}</AlertTitle>
      <AlertDescription maxWidth="sm">
        {t`This form is still work in progress, you can't respond to it.`}
      </AlertDescription>
      {canEdit && (
        <Button
          onClick={() => {
            setCurrentScreen('edit');
          }}
          my={2}
          size="sm"
          colorScheme="yellow"
        >
          {t`Edit this form`}
        </Button>
      )}
    </Alert>
  );
};
